import React from 'react';
import _ from 'lodash';
import {
  number,
  string,
  arrayOf,
  shape,
} from 'prop-types';

import './TravelInsuranceFunnelRightSide.scss';

class TravelInsuranceFunnelRightSide extends React.Component {
  constructor() {
    super();
    this.getFirstImgSrc = this.getFirstImgSrc.bind(this);
    this.getSecondImgSrc = this.getSecondImgSrc.bind(this);
    this.getThirdImgSrc = this.getThirdImgSrc.bind(this);
  }

  getFirstImgSrc() {
    const { rightSideImg, insuranceType } = this.props;
    const { value: insuranceTypeValue } = insuranceType;
    return _.get(
      rightSideImg,
      `insuranceType[${insuranceTypeValue}].src`,
      _.get(rightSideImg, 'insuranceType.DEFAULT.src')
    );
  }

  getSecondImgSrc() {
    const { rightSideImg, destinations } = this.props;
    const nonEmptyDestinations = destinations.filter(destination => !_.isEmpty(destination));
    if (nonEmptyDestinations.length === 1) {
      const localValue = _.get(nonEmptyDestinations, '[0].value');
      return _.get(
        rightSideImg,
        `destination[${localValue}].src`,
        _.get(rightSideImg, 'destination.DEFAULT.src')
      );
    }
    return _.get(rightSideImg, 'destination.DEFAULT.src');
  }

  getThirdImgSrc() {
    const { rightSideImg, travellers } = this.props;
    let familyNum = 0;
    let friendNum = 0;

    // TODO(victor): Assuming that SELF is always there
    let totalNum = 1;
    travellers.forEach((item) => {
      const { relationship } = item;
      if (relationship) {
        switch (relationship.value) {
          case 'COMPANION':
          case 'SPOUSE':
            friendNum++;
            totalNum++;
            break;
          case 'CHILD':
            familyNum++;
            totalNum++;
            break;
          default:
            break;
        }
      }
    });
    if (totalNum === 1) {
      return rightSideImg.traveller.MYSELF.src;
    }
    if (totalNum === 2) {
      if (familyNum > 0) {
        return rightSideImg.traveller.FAMILY.src;
      }
      return rightSideImg.traveller.COMPANION.src;
    }
    if (friendNum > 2) {
      return rightSideImg.traveller.FRIEND.src;
    }
    return rightSideImg.traveller.FAMILY.src;
  }

  render() {
    const {
      steps,
      activeIndex,
      rightSideImg,
      insuranceType,
    } = this.props;

    return (
      <div className="ti-funnel-right-wrapper">
          {steps[activeIndex] !== 'COVERAGES'
            && (
              <div className="slide-img ti-funnel-right-camera-img">
                <img alt="" src={rightSideImg.camera.src} />
              </div>
            )}
          {steps[activeIndex] !== 'COVERAGES'
            && (
              <div className="slide-img ti-funnel-right-first-img">
                <img alt="" src={this.getFirstImgSrc()} />
              </div>
            )}
          {steps.indexOf('TRAVELLERS') <= activeIndex
            && insuranceType.value === 'SINGLE_PLAN'
            && steps[activeIndex] !== 'COVERAGES'
            && (
              <div className="slide-img ti-funnel-right-second-img">
                <img alt="" src={this.getSecondImgSrc()} />
              </div>
            )}
          {((steps.indexOf('START_DATE') <= activeIndex
            && steps.indexOf('START_DATE') !== -1)
            || (steps.indexOf('START_DATE_AND_END_DATE') <= activeIndex
            && steps.indexOf('START_DATE_AND_END_DATE') !== -1))
            && steps[activeIndex] !== 'COVERAGES'
            && (
              <div className="slide-img ti-funnel-right-third-img">
                <img alt="" src={this.getThirdImgSrc()} />
              </div>
            )}
          {steps[activeIndex] === 'COVERAGES'
            && (
              <div className="slide-img top">
                <img alt="" src={rightSideImg.extraCoverage.src} />
              </div>
            )}
        </div>
    );
  }
}

TravelInsuranceFunnelRightSide.propTypes = {
  steps: arrayOf(string),
  activeIndex: number,
  insuranceType: shape({}),
  destinations: arrayOf(shape({})),
  travellers: arrayOf(shape({})),
  rightSideImg: shape({}),
};

TravelInsuranceFunnelRightSide.defaultProps = {
  steps: [],
  activeIndex: 0,
  insuranceType: {},
  destinations: [],
  travellers: [],
  rightSideImg: {},
};

export default TravelInsuranceFunnelRightSide;
